(function () {
  function packLines(items, containerWidth, gap) {
    const indexed = items.slice().sort((a, b) => b.width - a.width);
    const lines = [];

    indexed.forEach((item) => {
      const line = lines.find((candidate) => {
        const extra = candidate.items.length > 0 ? gap : 0;
        return candidate.width + extra + item.width <= containerWidth;
      });

      if (line) {
        line.width += (line.items.length > 0 ? gap : 0) + item.width;
        line.items.push(item);
      } else {
        lines.push({ width: item.width, items: [item] });
      }
    });

    return lines;
  }

  function optimize(list) {
    const elements = Array.from(list.children);
    if (elements.length < 2) return;

    const containerWidth = list.clientWidth;
    if (!containerWidth) return;

    const gap = parseFloat(getComputedStyle(list).columnGap) || 0;

    const items = elements.map((el) => ({
      el: el,
      width: el.getBoundingClientRect().width,
    }));

    const lines = packLines(items, containerWidth, gap);

    const fragment = document.createDocumentFragment();
    lines.forEach((line) => {
      line.items.forEach((item) => fragment.appendChild(item.el));
    });
    list.appendChild(fragment);
  }

  function optimizeAll() {
    document.querySelectorAll('.product__highlights--boxed').forEach(optimize);
  }

  function debounce(fn, wait) {
    var timeoutId;
    return function () {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(fn, wait);
    };
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(optimizeAll);
  } else {
    optimizeAll();
  }

  window.addEventListener('load', optimizeAll);
  window.addEventListener('resize', debounce(optimizeAll, 150));
  window.addEventListener('orientationchange', optimizeAll);
})();
